import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { ResetPassword } from './../_models/ResetPassword';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { SignUp } from '../_models/sign-up';
import { SignUpService } from '../_services/sign-up.service';
import { Subscription } from 'rxjs';
import { MyErrorStateMatcher } from '../signup/signup.component';
import swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  resetFormGroup: FormGroup;
  resetPasswordForm: ResetPassword = new ResetPassword();
  public loading: boolean = false;

  constructor(
    private signUpService:SignUpService,
    private formbuilder: FormBuilder,
    private router: Router,
    private snotifyService: SnotifyService
    
  ) { }

  ngOnInit() {
    this.resetFormFormValidate();
  }

  resetFormFormValidate() {
    this.resetFormGroup = this.formbuilder.group({
      emailId: ['', [Validators.nullValidator]],
      newPassword: ['', [Validators.nullValidator]],
      confirmPassword: ['', [Validators.required, this.compareValidator('newPassword')]],
    });

  }
  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }
      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }
      return controlToCompare && controlToCompare.value !== c.value ? { 'compare': true } : null;
    };
  }
  matcher = new MyErrorStateMatcher();

  resetPassword(){


  if (this.resetFormGroup.valid) {
    this.resetPasswordForm.email = this.resetFormGroup.get('emailId').value;
    this.resetPasswordForm.hashPassword = this.resetFormGroup.get('newPassword').value;
    console.log("Reset password Form" +JSON.stringify(this.resetPasswordForm))
    this.loading = true;
    this.signUpService.resetPassword(this.resetPasswordForm).subscribe(resp=>{
      this.loading = false;
      if (resp.status == 200) {
        let msg = "Password Changed successfully!";
        let action = ''
        this.snotifyService.success(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })

        this.router.navigate(['/login']);
      }
      this.resetFormGroup.reset();
    },
      error => {
        this.loading = false;
        let msg = "Invalid User";
        let action = ''
        this.snotifyService.error(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })

      });
  }
    
    
  }
  


}
